export const updateDatiModPagBonificoEstero = (unDato, unActionType) => {
    return {
        type: unActionType,
        unDato
    }
}